export const setUsers = ({ commit }, payload) => {
    commit("setUsers", payload);
};
export const setUserForm = ({ commit }, payload) => {
    commit("setUserForm", payload);
};
export const setUserPerfil = ({ commit }, payload) => {
    commit("setUserPerfil", payload);
};
export const setsetPerfilUser = ({ commit }, payload) => {
    commit("setsetPerfilUser", payload);
};
export const setPerfilUsuaro = ({ commit }, payload) => {
    commit("setPerfilUsuaro", payload);
};
export const setApisUser = ({ commit }, payload) => {
    commit("setApisUser", payload);
};
export const setDadoGerais = ({ commit }, payload) => {
    commit("setDadoGerais", payload);
};
export const setStatus = ({ commit }, payload) => {
    commit("setStatus", payload);
};
export const setStatusColor = ({ commit }, payload) => {
    commit("setStatusColor", payload);
};
export const setPerfil = ({ commit }, payload) => {
    commit("setPerfil", payload);
};
export const setApisConsumed = ({ commit }, payload) => {
    commit("setApisConsumed", payload);
};
export const setAmbience = ({ commit }, payload) => {
    commit("setAmbience", payload);
};
export const setHeaderApis = ({ commit }, payload) => {
    commit("setHeaderApis", payload);
};
export const setHeaderUsres = ({ commit }, payload) => {
    commit("setHeaderUsres", payload);
};
export const setLabels = ({ commit }, payload) => {
    commit("setLabels", payload);
};

export const setUserStatusForm = ({ commit }, payload) => {
    commit("setUserStatusForm", payload);
};

export const setUserStatus = ({ commit }, payload) => {
    commit("setUserStatus", payload);
};

export const setUserPerfilForm = ({ commit }, payload) => {
    commit("setUserPerfilForm", payload);
};

export const setUserEmailForm = ({ commit }, payload) => {
    commit("setUserEmailForm", payload);
};

export const setUserPhoneForm = ({ commit }, payload) => {
    commit("setUserPhoneForm", payload);
};
export const setUserCpfForm = ({ commit }, payload) => {
    commit("setUserCpfForm", payload);
};
export const setUserCnpjForm = ({ commit }, payload) => {
    commit("setUserCnpjForm", payload);
};
export const setUserCorporateNameForm = ({ commit }, payload) => {
    commit("setUserCorporateNameForm", payload);
};
export const setUserFantasyNameForm = ({ commit }, payload) => {
    commit("setUserFantasyNameForm", payload);
};
export const setUserLastNameForm = ({ commit }, payload) => {
    commit("setUserLastNameForm", payload);
};

export const setUserNameForm = ({ commit }, payload) => {
    commit("setUserNameForm", payload);
};

export const setBackupUser = ({ commit }, payload) => {
    commit("setBackupUser", payload);
};

